<template>
    <rc-alert-local-storage
        v-if="show_announcement"
        icon=""
        :wrap_early="wrap_early"
        :storage_key="storage_key"
        @dismissed="onDismissed"
    >
        <template #title>
            <h3 class="text-h6 mb-3">
                <strong>⚠️ <strong>No Lightboxes Detected</strong> ⚠️</strong>
            </h3>
        </template>

        <div>
            <p>
                You can now use RedChirp Lightboxes to collect text <em><strong>and</strong></em> email consent right on
                your website with branded pop-ups. Early results are impressive: beta testers saw <strong>160% more
                    opt-ins in their first 30 days!</strong>
            </p>

            <p>
                Your RedChirp account does not have a Lightbox turned on yet — and they're included in your subscription
                at no extra cost.
            </p>

            <div class="d-flex flex-wrap flex-nowrap-md align-center gap-2">
                <p class="mb-0">
                    <rc-link
                        href="https://redchirp.com/lightboxes-collect-text-and-email-consent-right-on-your-website/"
                        text="Learn How to Add a Lightbox"
                    />
                </p>

                <span class="d-none d-sm-block nudge-up">or</span>

                <p class="mb-0">
                    <rc-link
                        href="https://app.redchirp.com/app/forms/3c5f5129-93cc-4eac-a7a6-d813cdb2f6d0"
                        text="Request Help"
                    />
                </p>
            </div>
        </div>
    </rc-alert-local-storage>
</template>

<script>
export default {
    name: 'LightboxAwareness',

    data() {
        return {
            show_announcement: false,
            storage_key: 'rc-dismissed-lightbox-awareness',
        }
    },

    props: {
        /**
         * In lieu of container queries, which are not well-supported enough yet, this prop
         * can be set to true to make the alert wrap its contents sooner, for use in
         * narrower containers.
         */
        wrap_early: {
            type: Boolean,
            default: false
        }
    },

    mounted() {
        const dismissed = localStorage.getItem(this.storage_key);
        this.is_dismissed = dismissed === 'true';

        if (!this.is_dismissed) {
            this.loadLightboxDetection();
        } else {
            this.$emit('visibility-changed', !this.is_dismissed);
        }
    },

    methods: {
        loadLightboxDetection() {
            this.$rc.rest({
                spinner: false,
                endpoint: 'GET: /api/v1/announcements/announcement-lightbox-no-lightboxes-detected/:organization_id',

                params: {
                    organization_id: this.$rc.getOrganizationId(),
                },

                on_success: (data) => {
                    this.show_announcement = data?.show_announcement ?? false;
                    this.$emit('visibility-changed', this.show_announcement);
                },

                on_error: () => {
                    this.show_announcement = false;
                    this.$emit('visibility-changed', false);
                },
            });
        },

        onDismissed() {
            this.is_dismissed = true;
            this.$emit('visibility-changed', false);
        }
    }
}
</script>

<style lang="scss" scoped>
.nudge-up {
    padding-bottom: 2px;
}
</style>